import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_HOURS_WORKED_TREND } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";

/*
 * Hours (or amount) logged per period - the Hours Worked Trend line chart.
 *
 * Request:
 *   { in_tenant_id, in_provider_id, in_start_date, in_end_date,
 *     in_group_by: "month" | "quarter" | "year",
 *     in_sort_number: 1, in_sort_order: "ASC" }
 *
 *   in_start_date / in_end_date are required - the endpoint answers
 *   "Start Date is required." otherwise. in_group_by accepts only the three
 *   values above; anything else comes back with no body at all.
 *
 * Response row:
 *   { period_label: "Jul 2025", total_hours: 141, total_minutes: 0, total_amount: 3644.16 }
 *
 *   period_label is "Jul 2025" / "Q3 2025" / "2025" per grouping. Every row
 *   carries both hours and amount, so the card's Hours / Amount strip is a
 *   client-side choice and never refetches.
 *
 * Normalized shape: { category, hours, amount }[]
 */

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const normalizeTrendRow = (row) => ({
  category: String(row?.period_label ?? ""),
  // Hours and minutes arrive as separate integers; the chart works in decimal
  // hours and formatHours turns them back into "80h 30m".
  hours: toNumber(row?.total_hours) + toNumber(row?.total_minutes) / 60,
  amount: toNumber(row?.total_amount),
});

export const getHoursWorkedTrend = async (
  cookiesData,
  dispatch,
  { providerId, periodTypeMasterKey, startDate, endDate } = {},
  scope = {}
) => {
  if (!cookiesData || !providerId || !startDate || !endDate) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      // in_tenant_id: cookiesData.out_tenant_id,
      // in_provider_id: providerId,
      // in_start_date: startDate,
      // in_end_date: endDate,
      // in_group_by: granularity,
      // in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      // in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
      in_period_type_mstr_key: periodTypeMasterKey,
      ...scope,
    };

    const response = await POSTAPI(false, GET_HOURS_WORKED_TREND, null, apiHeaders, requestBody, dispatch);
    const returnCode = response?.data?.out_parameters?.out_ret_code;

    if (returnCode !== API_CONSTANTS.SUCCESS_CODE && returnCode !== API_CONSTANTS.RECORDS_NOT_FOUND_CODE) {
      return [];
    }

    const rowResult = response?.data?.row_result;

    if (!Array.isArray(rowResult)) return [];

    return rowResult.map(normalizeTrendRow);
  } catch (error) {
    console.error("Error fetching hours worked trend:", error);
    return [];
  }
};
